import {MutationTree} from 'vuex';
import {Files, FilesInitState} from '@/store/files/files.types';

export const FilesMutations: MutationTree<FilesInitState> = {
  ['templateInit'](state: FilesInitState) {
    // state.loading = true
  },
  ['mutationGetFiles'](state: FilesInitState, payload: Files[]) {
    console.log('DEBUG: payload', payload);
    state.files = payload;
  },
  ['mutationGetProfile'](state: FilesInitState, payload: Files[]) {
    state.profile = payload;
  }
};
